// extracted by css-extract-rspack-plugin
export default {"profile":"VFRWm","profile_without_ad":"W05qL","profileWithoutAd":"W05qL","avatar_override":"jRIeu","avatarOverride":"jRIeu","#":"nuAJS"};